<template>
    <div style="padding-top:1rem;">
        <van-form @submit="onSubmit">



            <van-field v-model="form.summary" name="模板" label="模板" placeholder="模板"
                :rules="[{ required: true, message: '请选择模板' }]" @click="popup_show = true" />

            <van-field v-model="form.userName" name="值班人员姓名" label="值班人员姓名" placeholder="值班人员姓名" @blur="getUserList"
                :rules="[{ required: true, message: '请选择值班人员姓名' }]">
            </van-field>

            <van-field v-model="form.jobNo" name="值班人员工号" label="值班人员工号" placeholder="值班人员工号" @blur="getUserList"
                :rules="[{ required: true, message: '请输入值班人员工号' }]">
            </van-field>


            <van-field readonly clickable name="值班日期" v-model="form.beginstr" label="值班日期" placeholder="点击选择值班日期"
                @click="showCalendar = true" :rules="[{ required: true, message: '请选择值班日期' }]">
                <template #input>
                    <div>{{ form.beginstr }} <span v-if="form.templeId === 11">- {{ form.endstr }} </span></div>
                </template>
            </van-field>

            <van-calendar v-if="form.templeId != '11'" v-model="showCalendar" @confirm="onDataConfirm" />
            <van-calendar v-else v-model="showCalendar" type="range" @confirm="onDataConfirm2" />

            <van-field v-model="form.description" name="日志" label="日志" placeholder="日志" />

            <van-field name="同步钉钉" label="同步钉钉" placeholder="同步钉钉">
                <template #input>
                    <van-switch v-model="form.isDing" size="20" />
                </template>

            </van-field>

            <div style="margin: 16px;" v-if="!form.id">
                <van-button :loading='btnloading' round block type="info" native-type="submit">提交</van-button>
            </div>
            <div style="
            padding: 16px;
            display:flex;
            width:100%;
            box-sizing: border-box;
            " v-else>
                <van-button native-type="button"
                    style="flex:1;border-top-left-radius:50px;border-bottom-left-radius:50px" type="danger"
                    @click="delform(_id)">删除</van-button>
                <van-button style="flex:1;border-top-right-radius:50px;border-bottom-right-radius:50px" type="warning"
                    native-type="submit">编辑</van-button>
            </div>
        </van-form>


        <van-popup round v-model="popup_show" position="bottom" :style="{ height: '30%' }">
            <van-picker title="模板" show-toolbar :columns="templelist" @confirm="onConfirm" @cancel="onCancel"
                @change="onChange">
            </van-picker>
        </van-popup>


        <van-popup round v-model="popup_Jobshow" position="bottom" :style="{ height: '30%' }">
            <van-picker title="请选择工号" show-toolbar :columns="joblist" @confirm="onJobConfirm" @cancel="onJobCancel"
                @change="onJobChange">
            </van-picker>
        </van-popup>

    </div>
</template>
<script>
import moment from "moment";
import { getId, getTempleList, AddScheduling, Updateform, delform } from "@/api/Scheduling/Scheduling";
import { getUserInfo } from '@/api/user'
export default {

    data() {
        return {
            popup_Jobshow: false,
            popup_show: false,
            datearr: null,
            beginstr: '',
            endstr: '',
            form: {
                id: null,
                userId: null, // abpid
                beginTime: null,
                beginstr: null,
                endTime: null,
                endstr: null,
                summary: null,
                description: null,
                location: null,
                sendms: null,
                sendCard: null,
                templeId: null,
                userName: null, // 名字
                origin: null,
                departmentName: null,
                isSign: null,
                jobNo: null, // 工号
                createType: null,

                isDing: false,// 钉钉

            },
            joblist: [],
            templelist: [],
            showCalendar: false,
            btnloading: false,
            res: [],
        };
    },
    methods: {
        clearall(e) {
            console.log(123, e);
            this.$set(this.form, 'userId', null)
            this.$set(this.form, 'jobNo', null)
            this.$set(this.form, 'userName', null)
        },
        async delform() {
            this.btnloading = true;

            await delform(this.form.id);
            this.$message.success('删除成功');

            this.btnloading = false;
            this.$emit('close');
        },
        getUserList() {
            if (!this.form.userName && !this.form.jobNo) {
                this.$set(this.form, 'userId', null)
                this.$set(this.form, 'jobNo', null)
                this.$set(this.form, 'userName', null)
                return;
            }

            getUserInfo(this.form.jobNo, this.form.userName).then(res => {
                console.log(res, 'res');
                this.res = res;
                if (res.length == 0) {
                    this.$message({
                        message: `无法查到对应的用户信息`,
                        type: "error",
                    });

                    this.$set(this.form, 'userId', null)
                    this.$set(this.form, 'jobNo', null)
                    this.$set(this.form, 'userName', null)
                }
                else {
                    // this.$set(this.form, 'userId', res[0].id)
                    console.log(res, 'res');
                    /* eslint-disable no-debugger */
                    debugger;
                    if (res.length > 1) {
                        console.log(res, 'res');
                        if (this.form.userName) {
                            this.joblist = res.map(t => t.userName);
                            console.log(this.joblist, 'this.joblist');
                            this.$set(this.form, 'userName', res[0].name)
                            this.popup_Jobshow = true;
                        }

                    } else {
                        console.log(1111, 'res');
                        this.$set(this.form, 'userId', res[0].id)
                        this.$set(this.form, 'jobNo', res[0].userName)
                        this.$set(this.form, 'userName', res[0].name)
                    }

                }
            })
        },
        onDataConfirm2(date) {
            const [start, end] = date;
            this.$set(this.form, 'beginTime', moment(start).format("yyyy-MM-DD hh:mm:ss"));
            this.$set(this.form, 'endTime', moment(end).format("yyyy-MM-DD hh:mm:ss"));
            this.$set(this.form, 'beginstr', moment(start).format("yyyy-MM-DD"))
            this.$set(this.form, 'endstr', moment(end).format("yyyy-MM-DD"))
            this.showCalendar = false;
        },
        onDataConfirm(date) {
            console.log(date)
            this.$set(this.form, 'beginTime', moment(date).format("yyyy-MM-DD hh:mm:ss"));
            this.$set(this.form, 'endTime', moment(date).format("yyyy-MM-DD hh:mm:ss"));
            this.$set(this.form, 'beginstr', moment(date).format("yyyy-MM-DD"))
            this.$set(this.form, 'endstr', '')
            // this.value = `${date.getMonth() + 1}/${date.getDate()}`;
            this.showCalendar = false;
        },
        onJobChange(v, e, i) {
            console.log(v, e, i, 'e', this.res.find(t => t.userName == e));
            this.$set(this.form, 'jobNo', e);
            this.$set(this.form, 'userId', this.res.find(t => t.userName == e).id);
            // this.popup_Jobshow = false;
        },
        onJobConfirm(e) {
            console.log(e, 'e', this.res.find(t => t.userName == e));
            this.$set(this.form, 'jobNo', e);
            this.$set(this.form, 'userId', this.res.find(t => t.userName == e).id);
            this.popup_Jobshow = false;
        },
        onJobCancel() {
            this.popup_Jobshow = false;
        },

        onChange(v, e, i) {
            console.log(v, e, i, 'e');
            this.$set(this.form, 'templeId', e.value);
            this.$set(this.form, 'summary', e.text);
            // this.popup_show = false;
        },
        onConfirm(e) {
            console.log(e, 'e');
            this.$set(this.form, 'templeId', e.value);
            this.$set(this.form, 'summary', e.text);
            this.popup_show = false;
        },
        onCancel() {
            this.popup_show = false;
        },
        clearform() {
            this.form = {
                id: null,
                userId: null, // abpid
                beginTime: null,
                beginstr: null,
                endstr: null,
                endTime: null,
                summary: null,
                description: null,
                location: null,
                sendms: null,
                sendCard: null,
                templeId: null,
                userName: null, // 名字
                origin: null,
                departmentName: null,
                isSign: null,
                jobNo: null, // 工号
                createType: null,
                templeName: null,
                isDing: false,// 钉钉
            };
        },
        async dialogOpen(id, createtype) {
            try {
                console.log(id, 'id');

                this.clearform();

                if (id) {
                    this.$set(this.form, 'id', id);
                    var res = await getId(this.form.id);
                    Object.keys(this.form).forEach(key => {
                        try {
                            this.$set(this.form, key, res[key]);
                        } catch (e) {
                            console.log(this.form, key, res[key]);
                        }
                    });
                    this.$set(this.form, 'beginstr', moment(this.form.beginTime).format("yyyy-MM-DD"))
                    this.$set(this.form, 'endstr', moment(this.form.endTime).format("yyyy-MM-DD"))
                }
                this.$set(this.form, 'createType', createtype);
                getTempleList(createtype).then(res => {
                    this.templelist = res.items.map(t => {
                        t.text = t.summary;
                        t.value = t.id;
                        return t;
                    });
                })
            } catch (e) {
                console.log(e);
            }


        },
        async onSubmit() {
            try {
                this.btnloading = true;
                if (this.form.id) {
                    await Updateform(this.form, this.form.id)
                }
                else {
                    await AddScheduling(this.form)
                }
                this.$message.success('保存成功');
            }
            catch (error) {
                console.log(error);
                this.$message.error('保存失败');
            }
            finally {
                this.btnloading = false;
                await this.$emit('close');

            }
        }
    }
}
</script>
<style scoped></style>